/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  UploadImage200,
  UploadImageBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Upload an image file to cloud storage.
Supports PNG, JPG, WEBP, and GIF formats. Maximum file size: 5MB.
Images are automatically optimized and stored in entity-specific folders.
Returns secure URLs for use in entity settings, invoices, and other documents.
 * @summary Upload image
 */
export type uploadImageResponse200 = {
  data: UploadImage200
  status: 200
}

export type uploadImageResponse400 = {
  data: Error
  status: 400
}

export type uploadImageResponse401 = {
  data: Error
  status: 401
}

export type uploadImageResponse403 = {
  data: Error
  status: 403
}

export type uploadImageResponse404 = {
  data: Error
  status: 404
}

export type uploadImageResponse422 = {
  data: ValidationError
  status: 422
}

export type uploadImageResponse500 = {
  data: Error
  status: 500
}

export type uploadImageResponseSuccess = (uploadImageResponse200) & {
  headers: Headers;
};
export type uploadImageResponseError = (uploadImageResponse400 | uploadImageResponse401 | uploadImageResponse403 | uploadImageResponse404 | uploadImageResponse422 | uploadImageResponse500) & {
  headers: Headers;
};

export type uploadImageResponse = (uploadImageResponseSuccess | uploadImageResponseError)

export const getUploadImageUrl = () => {


  

  return `/upload/image`
}

export const uploadImage = async (uploadImageBody: UploadImageBody, options?: RequestInit): Promise<uploadImageResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadImageBody.file);

  return customFetch<uploadImageResponse>(getUploadImageUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}
  

